
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LucideIcon } from "lucide-react";

interface IconInputProps {
  id: string;
  label: string;
  type: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  required?: boolean;
  disabled?: boolean;
  minLength?: number;
  Icon: LucideIcon;
  error?: string;
}

export function IconInput({
  id,
  label,
  type,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  minLength,
  Icon,
  error,
}: IconInputProps) {
  return (
    <div className="space-y-1">
      <Label htmlFor={id} className="text-left block">{label}</Label>
      <div className="relative">
        <Icon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 h-4 w-4" />
        <Input
          id={id}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`pl-10 rounded-lg ${error ? "border-red-500 focus:ring-red-500" : ""}`}
          required={required}
          disabled={disabled}
          minLength={minLength}
        />
      </div>
      {error && (
        <p className="text-xs text-red-500 mt-1">{error}</p>
      )}
    </div>
  );
}
